import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { ZoomIn, ZoomOut } from "lucide-react";

export function ImageZoom({ src, alt, open, onOpenChange }) {
  const [zoom, setZoom] = useState(false);
  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) setZoom(false);
        onOpenChange(o);
      }}
    >
      <DialogContent
        className="max-w-5xl w-[95vw] p-0 bg-[#0A0A0A] border border-white/10 rounded-none overflow-hidden"
        data-testid="image-zoom-dialog"
      >
        <DialogTitle className="sr-only">{alt || "Image"}</DialogTitle>
        <div className="relative">
          <div
            className={`w-full max-h-[85vh] overflow-auto thin-scroll ${zoom ? "cursor-zoom-out" : "cursor-zoom-in"}`}
            style={{ touchAction: "pinch-zoom" }}
          >
            <img
              src={src}
              alt={alt || "Image"}
              onClick={() => setZoom((z) => !z)}
              data-testid="image-zoom-img"
              className={`mx-auto block max-w-full transition-transform duration-300 ${zoom ? "scale-[2] origin-top" : "scale-100"}`}
            />
          </div>
          <button
            onClick={() => setZoom((z) => !z)}
            data-testid="image-zoom-toggle"
            className="absolute bottom-3 right-3 h-10 w-10 flex items-center justify-center bg-black/70 border border-white/20 text-white hover:bg-white hover:text-black transition-colors"
            aria-label={zoom ? "Zoom out" : "Zoom in"}
          >
            {zoom ? <ZoomOut className="h-5 w-5" /> : <ZoomIn className="h-5 w-5" />}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
